import { ChevronDown, ChevronUp, ListOrdered } from 'lucide-react';
import { useState } from 'react';
import { RoundActionLogEntry } from 'types/game';
import { formatCurrencyAmount } from 'lib/currency-format';

interface ActionLogPanelProps {
  actions: RoundActionLogEntry[];
  roundNumber: number;
  currencySymbol?: string;
  currencyCode?: string | null;
  collapsed?: boolean;
  embedded?: boolean;
}

export default function ActionLogPanel({
  actions,
  roundNumber,
  currencySymbol = '',
  currencyCode,
  collapsed: initialCollapsed = false,
  embedded = false,
}: ActionLogPanelProps) {
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  const body = (
    <>
      {!embedded && (
        <button
          type="button"
          className="tp-action-log-toggle"
          onClick={() => setCollapsed((v) => !v)}
          aria-expanded={!collapsed}
        >
          <ListOrdered size={16} />
          <span>Round log</span>
          {collapsed ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
        </button>
      )}

      {(embedded || !collapsed) && (
        <div className="tp-action-log-body">
          <p className="tp-action-log-heading">
            Round {roundNumber || 1} · {actions.length} action{actions.length === 1 ? '' : 's'}
          </p>
          {actions.length === 0 ? (
            <p className="tp-action-log-empty">Actions appear here as the hand progresses.</p>
          ) : (
            <ol className="tp-action-log-list">
              {actions.map((entry) => (
                <li key={entry.id} className="tp-action-log-item">
                  <div className="tp-action-log-item-main">
                    <span className="tp-action-log-player">{entry.username}</span>
                    <span className="tp-action-log-label">{entry.actionLabel}</span>
                  </div>
                  {entry.amount > 0 && (
                    <span className="tp-action-log-amount">
                      {formatCurrencyAmount(currencySymbol, entry.amount, currencyCode)}
                    </span>
                  )}
                </li>
              ))}
            </ol>
          )}
        </div>
      )}
    </>
  );

  if (embedded) {
    return <div className="tp-action-log-panel tp-action-log-panel-embedded">{body}</div>;
  }

  return (
    <aside className="tp-action-log-panel tp-floating-rail tp-floating-rail-right z-40 hidden xl:flex">
      {body}
    </aside>
  );
}
